// extracted by mini-css-extract-plugin
module.exports = {"orderDynamic":"OrderDynamic_style_orderDynamic__29UVU"};